import { createContext, useContext, useEffect, useState } from "react";

const ca = {
  meta: { title: "Fes Espai Olot · Trasters automatitzats i segurs a Olot", lang: "ca" },
  nav: { avantatges: "Avantatges", seguretat: "Seguretat", mides: "Mides i tarifes", "com-funciona": "Com funciona", reserve: "-20% Reserva", mobileReserve: "Reserva amb -20%", open: "Obrir menú", close: "Tancar menú", home: "Inici", language: "Idioma" },
  hero: {
    badge: "Sense claus físiques · Protecció total",
    pre: "Trasters i Minimagatzems a Olot:",
    lines: [["Automatització"], ["Total i Màxima"], ["", "Seguretat"]],
    subtitle: "Accedeix al teu espai de la manera més fàcil des del teu smartphone. Un centre 100% automatitzat amb la protecció més avançada per als teus béns.",
    cta: "Reserva el teu traster amb un 20% de descompte",
    sizes: "Veure mides i preus",
    door: "Porta B-07 · Oberta des del mòbil",
    discount: "obertura",
    alt: "Passadís del centre de trasters amb portes taronja i taupe",
  },
  marquee: ["Accés automatitzat des del mòbil", "Sense claus físiques", "Videovigilància IP en HD", "Pany electrònic intel·ligent", "Gestió 100% digital", "-20% d'obertura a Olot"],
  benefits: {
    eyebrow: "Per què Fes Espai",
    title: ["Fàcil per a tu.", "Blindat per a la resta."],
    intro: "Dos pilars, una sola promesa: accés totalment automatitzat des del teu mòbil i la màxima protecció per a tot el que hi guardes.",
    items: [
      { t: "Accés Automatitzat", d: "Entra còmodament des de l'App del teu mòbil, sense necessitat de claus físiques ni complicacions." },
      { t: "Seguretat Avançada", d: "Control d'accés individualitzat, central d'alarma intel·ligent i videovigilància IP en alta definició." },
      { t: "Gestió 100% Digital", d: "Reserva, signatura de contracte i gestió sense paperassa des de la comoditat de casa teva." },
      { t: "Espai Cuidat i Protegit", d: "Instal·lacions modernes, seques i dissenyades per mantenir el teu material en perfecte estat." },
    ],
  },
  security: {
    eyebrow: "Seguretat i tecnologia",
    title: ["Protecció absoluta", "per al que més valores."],
    intro: "Tres capes de protecció treballant juntes per a la màxima tranquil·litat de la teva família o negoci.",
    cam: { live: "En directe · CAM 03", alt: "Vista de càmera IP del passadís de trasters", t: "Càmeres de seguretat IP en directe", d: "Videovigilància en alta definició de tots els passadissos i accessos del centre." },
    lock: { t: "Pany electrònic intel·ligent", d: "Cada traster té el seu propi pany digital: només s'obre amb el teu mòbil, sense claus que es puguin perdre o copiar." },
    audit: { t: "Control d'accés auditat", log: ["Identitat verificada", "Porta B-07 desbloquejada", "Accés registrat a l'historial", "Alarma rearmada"] },
  },
  pricing: {
    eyebrow: "Mides i tarifes",
    title: ["Quin espai", "necessites?"],
    intro: "Toca o passa per sobre de cada mida per veure-la a escala. Preus orientatius, mes a mes.",
    bullets: ["Accés automatitzat des del mòbil", "Sense claus físiques", "Videovigilància IP en alta definició"],
    scale: "Escala · 9 m²",
    popular: "Més demanat",
    from: "Des de",
    month: "/ mes",
    reserve: "Reservar Mida",
    plans: {
      XS: "Per a documents, caixes petites o objectes personals.",
      S: "Per a caixes, roba de temporada o maletes.",
      M: "Per a mobles petits, eines d'autònoms o equip esportiu.",
      L: "Ideal per a mudances de pisos o stock comercial.",
      XL: "Magatzem d'alta capacitat per a empreses i professionals.",
    },
  },
  steps: {
    eyebrow: "Com funciona en 3 passos senzills",
    title: ["Del mòbil a la porta,", "sense claus."],
    badge: "La teva clau és el mòbil",
    alt: "Obrint la porta del traster amb el mòbil",
    items: [
      { t: "Tria la teva mida", d: "Selecciona l'espai que millor s'adapta a les teves necessitats." },
      { t: "Rep el teu accés digital", d: "Contractació 100% online en pocs clics." },
      { t: "Entra fàcilment", d: "Utilitza el teu mòbil per obrir la porta i accedir al teu traster amb total tranquil·litat i seguretat." },
    ],
  },
  lead: {
    eyebrow: "Llista prioritària · Places limitades",
    title: ["Propera Obertura a Olot", "Aconsegueix el teu descompte"],
    text: "Deixa'ns les teves dades i sigues el primer en triar la millor ubicació amb un 20% de descompte durant els primers 3 mesos.",
    alt: "Traster obert amb caixes i bicicleta",
    name: "Nom complet", phone: "Telèfon", email: "Email", size: "Mida d'interès",
    namePh: "Ex. Laia Puig", emailPh: "nom@correu.cat",
    consent: ["Accepto la", "Política de Privacitat", "i rebre informació sobre l'obertura."],
    submit: "Vull la meva oferta d'obertura",
    errSize: "Tria la mida de traster que t'interessa",
    errConsent: "Cal acceptar la Política de Privacitat",
    errOff: "El formulari no està disponible ara mateix",
    errGeneric: "Revisa les dades i torna-ho a provar.",
    ok: "Rebut! Et contactarem abans de l'obertura amb el teu 20% de descompte.",
    doneTitle: "Ja ets a la llista!",
    doneText: (s) => `Tens reservat el 20% de descompte durant els 3 primers mesos per a la mida ${s}. Et contactarem abans de l'obertura.`,
  },
  mobileCta: { text: "Reserva amb -20% d'obertura", btn: "Reservar" },
  footer: {
    rights: "Tots els drets reservats.",
    tagline: "Self Storage automatitzat · Olot, la Garrotxa",
    legal: {
      legal: { t: "Avís Legal", p: [
        "Aquest lloc web és titularitat de Fes Espai Olot, amb activitat de lloguer de trasters i minimagatzems automatitzats a Olot (Girona). [Raó social, NIF i domicili social pendents d'incorporar].",
        "L'accés i ús d'aquest web implica l'acceptació d'aquestes condicions. Els preus mostrats són orientatius i poden variar segons disponibilitat.",
        "Tots els continguts (textos, imatges, logotips) són propietat de Fes Espai Olot o disposen de llicència d'ús, i en queda prohibida la reproducció sense autorització.",
      ] },
      privacy: { t: "Política de Privacitat", p: [
        "D'acord amb el Reglament (UE) 2016/679 (RGPD) i la LOPDGDD 3/2018, t'informem que el responsable del tractament de les dades és Fes Espai Olot.",
        "Finalitat: gestionar la teva sol·licitud de reserva prèvia i informar-te de l'obertura i de l'oferta del 20% de descompte. Base legal: el teu consentiment.",
        "Les dades es conservaran fins a l'obertura del centre o fins que en sol·licitis la supressió. No es cediran a tercers excepte obligació legal.",
        "Pots exercir els drets d'accés, rectificació, supressió, oposició, limitació i portabilitat a través dels canals que t'indicarem en contactar-te, així com presentar una reclamació davant l'Autoritat Catalana de Protecció de Dades.",
      ] },
      cookies: { t: "Política de Cookies", p: [
        "Aquest web utilitza únicament cookies tècniques necessàries per al seu funcionament i, si escau, cookies analítiques anònimes per millorar l'experiència.",
        "No utilitzem cookies publicitàries ni de seguiment de tercers amb finalitats comercials.",
        "Pots configurar o eliminar les cookies des de la configuració del teu navegador en qualsevol moment.",
      ] },
    },
  },
};

const es = {
  meta: { title: "Fes Espai Olot · Trasteros automatizados y seguros en Olot", lang: "es" },
  nav: { avantatges: "Ventajas", seguretat: "Seguridad", mides: "Tamaños y tarifas", "com-funciona": "Cómo funciona", reserve: "-20% Reserva", mobileReserve: "Reserva con -20%", open: "Abrir menú", close: "Cerrar menú", home: "Inicio", language: "Idioma" },
  hero: {
    badge: "Sin llaves físicas · Protección total",
    pre: "Trasteros y Minialmacenes en Olot:",
    lines: [["Automatización"], ["Total y Máxima"], ["", "Seguridad"]],
    subtitle: "Accede a tu espacio de la forma más fácil desde tu smartphone. Un centro 100% automatizado con la protección más avanzada para tus bienes.",
    cta: "Reserva tu trastero con un 20% de descuento",
    sizes: "Ver tamaños y precios",
    door: "Puerta B-07 · Abierta desde el móvil",
    discount: "apertura",
    alt: "Pasillo del centro de trasteros con puertas naranja y taupe",
  },
  marquee: ["Acceso automatizado desde el móvil", "Sin llaves físicas", "Videovigilancia IP en HD", "Cerradura electrónica inteligente", "Gestión 100% digital", "-20% de apertura en Olot"],
  benefits: {
    eyebrow: "Por qué Fes Espai",
    title: ["Fácil para ti.", "Blindado para el resto."],
    intro: "Dos pilares, una sola promesa: acceso totalmente automatizado desde tu móvil y la máxima protección para todo lo que guardas.",
    items: [
      { t: "Acceso Automatizado", d: "Entra cómodamente desde la App de tu móvil, sin necesidad de llaves físicas ni complicaciones." },
      { t: "Seguridad Avanzada", d: "Control de acceso individualizado, central de alarma inteligente y videovigilancia IP en alta definición." },
      { t: "Gestión 100% Digital", d: "Reserva, firma de contrato y gestión sin papeleo desde la comodidad de tu casa." },
      { t: "Espacio Cuidado y Protegido", d: "Instalaciones modernas, secas y diseñadas para mantener tu material en perfecto estado." },
    ],
  },
  security: {
    eyebrow: "Seguridad y tecnología",
    title: ["Protección absoluta", "para lo que más valoras."],
    intro: "Tres capas de protección trabajando juntas para la máxima tranquilidad de tu familia o negocio.",
    cam: { live: "En directo · CAM 03", alt: "Vista de cámara IP del pasillo de trasteros", t: "Cámaras de seguridad IP en directo", d: "Videovigilancia en alta definición de todos los pasillos y accesos del centro." },
    lock: { t: "Cerradura electrónica inteligente", d: "Cada trastero tiene su propia cerradura digital: solo se abre con tu móvil, sin llaves que se puedan perder o copiar." },
    audit: { t: "Control de acceso auditado", log: ["Identidad verificada", "Puerta B-07 desbloqueada", "Acceso registrado en el historial", "Alarma rearmada"] },
  },
  pricing: {
    eyebrow: "Tamaños y tarifas",
    title: ["¿Qué espacio", "necesitas?"],
    intro: "Toca o pasa por encima de cada tamaño para verlo a escala. Precios orientativos, mes a mes.",
    bullets: ["Acceso automatizado desde el móvil", "Sin llaves físicas", "Videovigilancia IP en alta definición"],
    scale: "Escala · 9 m²",
    popular: "Más pedido",
    from: "Desde",
    month: "/ mes",
    reserve: "Reservar Tamaño",
    plans: {
      XS: "Para documentos, cajas pequeñas u objetos personales.",
      S: "Para cajas, ropa de temporada o maletas.",
      M: "Para muebles pequeños, herramientas de autónomos o equipo deportivo.",
      L: "Ideal para mudanzas de pisos o stock comercial.",
      XL: "Almacén de alta capacidad para empresas y profesionales.",
    },
  },
  steps: {
    eyebrow: "Cómo funciona en 3 pasos sencillos",
    title: ["Del móvil a la puerta,", "sin llaves."],
    badge: "Tu llave es el móvil",
    alt: "Abriendo la puerta del trastero con el móvil",
    items: [
      { t: "Elige tu tamaño", d: "Selecciona el espacio que mejor se adapta a tus necesidades." },
      { t: "Recibe tu acceso digital", d: "Contratación 100% online en pocos clics." },
      { t: "Entra fácilmente", d: "Utiliza tu móvil para abrir la puerta y acceder a tu trastero con total tranquilidad y seguridad." },
    ],
  },
  lead: {
    eyebrow: "Lista prioritaria · Plazas limitadas",
    title: ["Próxima Apertura en Olot", "Consigue tu descuento"],
    text: "Déjanos tus datos y sé el primero en elegir la mejor ubicación con un 20% de descuento durante los primeros 3 meses.",
    alt: "Trastero abierto con cajas y bicicleta",
    name: "Nombre completo", phone: "Teléfono", email: "Email", size: "Tamaño de interés",
    namePh: "Ej. Laia Puig", emailPh: "nombre@correo.es",
    consent: ["Acepto la", "Política de Privacidad", "y recibir información sobre la apertura."],
    submit: "Quiero mi oferta de apertura",
    errSize: "Elige el tamaño de trastero que te interesa",
    errConsent: "Debes aceptar la Política de Privacidad",
    errOff: "El formulario no está disponible ahora mismo",
    errGeneric: "Revisa los datos y vuelve a intentarlo.",
    ok: "¡Recibido! Te contactaremos antes de la apertura con tu 20% de descuento.",
    doneTitle: "¡Ya estás en la lista!",
    doneText: (s) => `Tienes reservado el 20% de descuento durante los 3 primeros meses para el tamaño ${s}. Te contactaremos antes de la apertura.`,
  },
  mobileCta: { text: "Reserva con -20% de apertura", btn: "Reservar" },
  footer: {
    rights: "Todos los derechos reservados.",
    tagline: "Self Storage automatizado · Olot, la Garrotxa",
    legal: {
      legal: { t: "Aviso Legal", p: [
        "Este sitio web es titularidad de Fes Espai Olot, con actividad de alquiler de trasteros y minialmacenes automatizados en Olot (Girona). [Razón social, NIF y domicilio social pendientes de incorporar].",
        "El acceso y uso de esta web implica la aceptación de estas condiciones. Los precios mostrados son orientativos y pueden variar según disponibilidad.",
        "Todos los contenidos (textos, imágenes, logotipos) son propiedad de Fes Espai Olot o disponen de licencia de uso, y queda prohibida su reproducción sin autorización.",
      ] },
      privacy: { t: "Política de Privacidad", p: [
        "De acuerdo con el Reglamento (UE) 2016/679 (RGPD) y la LOPDGDD 3/2018, te informamos de que el responsable del tratamiento de los datos es Fes Espai Olot.",
        "Finalidad: gestionar tu solicitud de reserva previa e informarte de la apertura y de la oferta del 20% de descuento. Base legal: tu consentimiento.",
        "Los datos se conservarán hasta la apertura del centro o hasta que solicites su supresión. No se cederán a terceros salvo obligación legal.",
        "Puedes ejercer los derechos de acceso, rectificación, supresión, oposición, limitación y portabilidad a través de los canales que te indicaremos al contactarte, así como presentar una reclamación ante la Autoridad Catalana de Protección de Datos.",
      ] },
      cookies: { t: "Política de Cookies", p: [
        "Esta web utiliza únicamente cookies técnicas necesarias para su funcionamiento y, en su caso, cookies analíticas anónimas para mejorar la experiencia.",
        "No utilizamos cookies publicitarias ni de seguimiento de terceros con fines comerciales.",
        "Puedes configurar o eliminar las cookies desde la configuración de tu navegador en cualquier momento.",
      ] },
    },
  },
};

const DICT = { ca, es };
const LangCtx = createContext({ lang: "ca", t: ca, setLang: () => {} });

export const LangProvider = ({ children }) => {
  const [lang, setLang] = useState(() => (localStorage.getItem("fes-lang") === "es" ? "es" : "ca"));
  const t = DICT[lang];
  useEffect(() => {
    localStorage.setItem("fes-lang", lang);
    document.documentElement.lang = t.meta.lang;
    document.title = t.meta.title;
  }, [lang, t]);
  return <LangCtx.Provider value={{ lang, t, setLang }}>{children}</LangCtx.Provider>;
};

export const useLang = () => useContext(LangCtx);

export const LangSwitch = ({ className = "" }) => {
  const { lang, setLang, t } = useLang();
  return (
    <div role="group" aria-label={t.nav.language} className={`inline-flex rounded-full border border-white/20 p-1 ${className}`} data-testid="lang-switch">
      {["ca", "es"].map((l) => (
        <button
          key={l}
          onClick={() => setLang(l)}
          aria-pressed={lang === l}
          data-testid={`lang-btn-${l}`}
          className={`rounded-full px-3 py-1.5 text-xs font-bold uppercase tracking-wider transition-[background-color,color] duration-300 ${
            lang === l ? "bg-[#F7D048] text-[#1f1f1f]" : "text-[#EDE6DC] hover:text-white"
          }`}
        >
          {l === "ca" ? "CA" : "ES"}
        </button>
      ))}
    </div>
  );
};
